/**
 * Returns the public-facing display name for a practitioner.
 * Uses artistName when available, falls back to firstName + lastName.
 */
export function getPractitionerDisplayName(
  p: { artistName?: string | null; firstName?: string | null; lastName?: string | null }
): string {
  if (p.artistName) return p.artistName;
  return `${p.firstName || ''} ${p.lastName || ''}`.trim() || 'Artiste';
}
